export default {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR'
};
